export default __webpack_public_path__ + "static/media/Image2.a761b597.png";